<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'MY_PROFILE_PAGE.TITLE' | translate }}
    </glxy-page-title>
  </glxy-page-toolbar>
  <!-- Content -->
  <glxy-page-wrapper [widthPreset]="'narrow'">
    <user-profile *ngIf="userUnified$ | async as userUnified" [unifiedUserId]="userUnified"></user-profile>
  </glxy-page-wrapper>
</glxy-page>
